import { Component, Input } from '@angular/core';

import { IMultiOrder } from '@cakeiteasy/web-utils';

/**Renders the contact details of the customer who placed the order */
@Component({
  standalone: false,
  selector: 'order-customer-info-block',
  templateUrl: './order-customer-info-block.component.html'
})
export class OrderCustomerInfoBlockComponent {
  @Input() multiOrder: IMultiOrder;
}
